import { WebglSettingsConverter } from "../webgl-settings-converter";

export class ItemsContainerWebglSettingsConverter extends WebglSettingsConverter {
  constructor(viewObjectConverters) {
    super();
    this.viewObjectConverters = viewObjectConverters;
  }

  _copyItem(itemSettings) {
    if (itemSettings === undefined) {
      return undefined;
    }
    let objConverter = this.viewObjectConverters.get(itemSettings.type);
    if (objConverter !== undefined) {
      let convertedItemSettings = objConverter.convert(itemSettings);
      if (convertedItemSettings !== undefined) {
        return convertedItemSettings;
      }
    }
    return undefined;
  }
}
